module.exports = __webpack_public_path__ + "static/img/a05.fba90ba6.jpg";